import API from '../../../../../services/api';

export const TRANSPORTISTAS_API = {
    get: async () => {
        return await API.get('/transportistas').then(res => res.data);
    },
    new: async (transportista) => {
        return API.post('/transportistas', transportista).then(res => res.data);
    },
    update: async (transportista) => {
        return API.put(`/transportistas/${transportista.id}`, transportista).then(res => res.data);
    },
    delete: async (transportistaId) => {
        return API.delete(`/transportistas/${transportistaId}`).then(res => res.data);
    }
}